export const TOOLTIP_PORTAL_ROOT_ID = 'vertex-tooltip-portal';
